import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'

const AppRouter = (route) => {
  return (
    <Switch>
      <Route
        path={route.match.path}
        render={(routeProps) => (
          <PageLayout>
            {require('./Qrcode').default(routeProps)}
          </PageLayout>
        )}
      />
    </Switch>
  )
}

export default AppRouter
